/* istanbul ignore file */
export default [
  {
    path: '/entitlements/roles',
    name: 'entitlements-roles',
    component: () => import('../views/Roles'),
    meta: {
      auth: true,
      can: { admin_role: 'write' }
    }
  },
  {
    path: '/entitlements/admins',
    name: 'entitlements-admins',
    component: () => import('../views/Admins'),
    meta: {
      auth: true,
      can: { admin: 'write' }
    }
  }
]
